import TenantCalendar from '../../components/settings/tenant/TenantCalendar'

const Calendar = () => {
  return (
    <div className="mb-2 flex w-full flex-col">
      <TenantCalendar />
    </div>
  )
}

export default Calendar
